import moment from "moment";
import React, { useEffect, useState } from "react";
import Loader from "../../../Components/Loader";
import JobService from "../../../Services/JobService";

import ReactPaginate from "react-paginate";
import { Spinner } from "react-bootstrap-v5";


export const OutstandingJobs = () => {

  const [jobItem, setJobItem] = useState([]);
  const [startDate, setStarDate] = useState();
  const [endDate, setEndData] = useState();
  const [searchField, setSearchField] = useState();
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getJobList();
  }, [searchField, startDate, endDate, currentPage]);

  const getJobList = () => {
    let param = { };
    param = {
      ...param,
      page: currentPage,
      limit: pagination.limit,
    };
    if (startDate) {
      param["start_date"] = getTimeStamp(startDate);
    }
    if (endDate) {
      param["end_date"] = getTimeStamp(endDate);
    }
    if (searchField) {
      param["search"] = searchField;
    }
    setLoader(true);
    JobService.getoutstandingJobs(param).then((result) => {
      if (result.status === true) {
        setJobItem(result.data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        if(result!==false) setLoader(false);
      }
    });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  const onPageChangeEvent = (e) => {
    setCurrentPage(e.selected + 1);
  };

  const manageLongStrings = (str) => {
    const threshold = 40
    return (str ? str.length>threshold ? `${str.slice(0,threshold)}...` : str : "-")
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex mb-3 justify-content-start align-items-end table_filter">
              <div className="col-2">
                <label>Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>

              <div className="col-2">
                <label>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setStarDate(e.target.value)}
                  value={startDate}
                />
              </div>
              <div className="col-2">
                <label>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndData(e.target.value)}
                  value={endDate}
                />
              </div>

              {/* <div >
            </div> */}
            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th rowSpan="2">S no.</th>
                    <th rowSpan="2">Job No.</th>
                    <th style={{ width : "20%" }} rowSpan="2">Customer Name</th>
                    <th style={{ width : "20%" }} rowSpan="2">Shipper Name</th>
                    <th rowSpan="2">Due Date</th>
                    {/* <th rowSpan="2">Total Amount</th>
                    <th rowSpan="2">Paid</th> */}
                    <th rowSpan="2">Due Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {(!loader && jobItem &&
                    jobItem.length > 0 &&
                    jobItem.map((val, key) => {
                        const { actual_amount, agreed_amount, booking_amount } = val.payment_information;
                        const actualAmount = typeof actual_amount==='number' ? actual_amount : 0
                        const agreedAmount = typeof agreed_amount==='number' ? agreed_amount : 0
                        const bookingAmount = typeof booking_amount==='number' ? booking_amount : 0
                        const grossAmount = Math.max(actualAmount, agreedAmount, bookingAmount);
                        const invoiceTotal = val.invoice.reduce((acc,cur)=> acc+=cur.paid,0)
                        const dueAmount = (grossAmount - invoiceTotal)
                      return (
                        <tr key={key}>
                          <td>{(key + 1) + (currentPage * pagination.limit)}</td>
                          <td>{val.job_token}</td>
                          <td className="str-hover-show" showfullonhover={val?.user_full_name}>{manageLongStrings(val?.user_full_name)}</td>
                          <td className="str-hover-show" showfullonhover={val.shipper}>{manageLongStrings(val.shipper)}</td>
                          <td>{moment(val.expacted_date).format("DD-MM-YYYY")}</td>
                          {/* <td>{getDueAmount(val)?.grossAmount}</td>
                          <td>{getDueAmount(val)?.paidAmount}</td> */}
                          <td>{dueAmount}</td>
                        </tr>
                      );
                    }))}
                </tbody>
              </table>

              <Loader isShow={loader} position="relative" />

              {jobItem && jobItem.length <= 0 && !loader && (
                  !loader && <div className="text-center w-100 bg-warning my-5">
                    <h6 className="py-2"> List Not Available </h6>
                  </div>
              )}

              {jobItem && !loader &&
                jobItem.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
            </div>
          </div>
        </div>
      </div>

  
    </div>
  )
}
